import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionAriaLabel: {
    defaultMessage: 'Return Details expander section',
    description: 'Aria label for the expandable return details section',
    id: 'd2+D0s',
  },
  sectionHeaderTitle: {
    defaultMessage: 'Return Details',
    id: 'yi7AVc',
    description: 'Expander title for the return details section',
  },
});
